<mb-alert type="notification" [dismissible]="true" (dismiss)="togglesCloseAlert()" *ngIf="openAlert" class='few-offer-alert'>
  <mb-alert-description>
    <ng-container *ngIf="occupancy < 85">
      <span i18n="@@few-offer__date-high-request">El destino está siendo muy solicitado para las fechas que estás buscando</span>&nbsp;
      <strong i18n="@@few-offer__book-accommodation-asap">¡Reservá tu alojamiento cuanto antes!</strong>
    </ng-container>
    <ng-container *ngIf="occupancy >= 85">
      <span i18n="@@few-offer__date-low-availability">Ya hay poca disponibilidad en el destino para las fechas que estás buscando</span>&nbsp;
      <strong i18n="@@few-offer__book-before-out">¡Reservá antes que se agote!</strong>
    </ng-container>
  </mb-alert-description>
</mb-alert>
